export const co2Calculator = displayedProduct => {
  let result = {};

  if (!displayedProduct || Object.keys(displayedProduct).length === 0) {
    return result;
  }

  const baseValue1 = displayedProduct.base_value_1;
  const baseValue2 = displayedProduct.base_value_2;
  const baseValue3 = displayedProduct.base_value_3;
  const { scaling_factor: scalingFactor } = displayedProduct;
  const lambda = displayedProduct.lambda_value;
  const { density } = displayedProduct;
  const { thickness } = displayedProduct;

  result = {
    a1A3GWPM2R1: baseValue1 * scalingFactor,
    a1A3GWPM2: (thickness * baseValue1 * scalingFactor) / lambda / 1000,
    a1A3GWPKg: (baseValue1 * scalingFactor) / (lambda * density),
    a1A3GWPM3: (baseValue1 * scalingFactor) / lambda,
    a1C4GWPM2R1: baseValue2 * scalingFactor,
    a1C4GWPM2: (thickness * baseValue2 * scalingFactor) / lambda / 1000,
    a1C4GWPKg: (baseValue2 * scalingFactor) / (lambda * density),
    a1C4GWPM3: (baseValue2 * scalingFactor) / lambda,
    a1C4GWPAvgDensity: density,
    a1C4GWPThermalResistance: thickness / lambda / 1000,
  };

  if (baseValue3) {
    result.hasBaseValue3 = true;
    result.a1A3GWPTotalM2R1 = baseValue3 * scalingFactor;
    result.a1A3GWPTotalM2 = (thickness * baseValue3 * scalingFactor) / lambda / 1000;
    result.a1A3GWPTotalKg = (baseValue3 * scalingFactor) / (lambda * density);
    result.a1A3GWPTotalM3 = (baseValue3 * scalingFactor) / lambda;
  }

  return result;
};
